import PropTypes from 'prop-types';
import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';
import { updateProfileManagementRelations } from '../general';
import { getFacilitators, sendFacilitatorsItemManagersInvitations, updateFacilitatorsItemManagers } from './index';

const updateFacilitatorsItem = ({ data, docId, where, managers, prevManagers }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(firebaseUpdate({ collection: 'facilitators', docId: id, data: d }));

        // -- after update
        const afterUpdate = item => {
            const reqs = [];

            // update managers data
            reqs.push(dispatch(updateFacilitatorsItemManagers({ docId: item.id, managers })));

            // update managers profileId assignations inside collections
            if (managers && managers.length) {
                reqs.push(
                    awaitRequests(
                        managers.map(manager =>
                            dispatch(
                                updateProfileManagementRelations({
                                    email: manager.email,
                                }),
                            ),
                        ),
                    ),
                );
            }

            return awaitRequests(reqs).then(res => {
                const updatedManagers = (res && res[0]) || {};
                const { managersSaved } = updatedManagers;

                // send email invitations
                return dispatch(sendFacilitatorsItemManagersInvitations(item, managers, prevManagers)).then(() => {
                    return promise({ item, managersSaved });
                });
            });
        };

        // -- single update
        if (data && docId) {
            return update(data, docId).then(updatedItem => afterUpdate(updatedItem));
        }

        // -- multiple update
        if (where && data) {
            return dispatch(getFacilitators({ where })).then(items => {
                return awaitRequests(items.map(item => update(data, item.id).then(updatedItem => afterUpdate(updatedItem))));
            });
        }

        return promise({ item: undefined, managersSaved: [] });
    };
};

updateFacilitatorsItem.propTypes = {
    managers: PropTypes.array,
    prevManagers: PropTypes.array,
};

updateFacilitatorsItem.defaultProps = {
    managers: [],
    prevManagers: [],
};

export default updateFacilitatorsItem;
